import { Link, Navigate } from 'react-router-dom';
import { BRAND } from '../brand';
import { useAuth } from '../auth/AuthProvider';
import { useTheme } from '../theme/ThemeProvider';

export function Home() {
  const { user, needsSetup } = useAuth();
  const { theme } = useTheme();
  // Brand-new deployment with no admin yet → straight to first-run setup.
  if (needsSetup && !user) return <Navigate to="/login" replace />;
  return (
    <div className="mx-auto max-w-3xl text-center">
      <img
        src={theme === 'dark' ? BRAND.logoSrc : BRAND.logoOriginal}
        alt={BRAND.name}
        className="mx-auto mb-8 w-full max-w-lg px-4"
      />
      <h1 className="sr-only">{BRAND.name}</h1>
      <p className="text-xs uppercase tracking-[0.3em] text-gold-400">
        {BRAND.location} · Est. {BRAND.established}
      </p>
      <p className="mx-auto mt-6 max-w-xl font-display text-lg italic text-cream-200/80">
        “{BRAND.tagline}”
      </p>

      <div className="mt-10 flex justify-center gap-4">
        {user ? (
          <Link to="/club" className="btn-primary">
            Enter the Club
          </Link>
        ) : (
          <Link to="/login" className="btn-primary">
            Member Log in
          </Link>
        )}
      </div>

      <div className="mt-16 grid gap-6 text-left sm:grid-cols-3">
        <FeatureCard title="Tasting Archive" body="Four decades of blind, scored tastings — searchable by producer, varietal, region, venue, and member." />
        <FeatureCard title="Live Tastings" body="Score each wine from your phone in real time, with live rankings and the grand reveal." />
        <FeatureCard title="Members Only" body="A private cellar of the club's history, reserved for members and their guests." />
      </div>
    </div>
  );
}

function FeatureCard({ title, body }: { title: string; body: string }) {
  return (
    <div className="card">
      <h3 className="mb-2 text-lg text-gold-200">{title}</h3>
      <p className="text-sm text-cream-300/80">{body}</p>
    </div>
  );
}
